export default __webpack_public_path__ + "static/07-ced1f71db9325c7dcfc47d6abf4b18a2.jpg";